import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { currentUser } from 'redux/session/selectors';
import { updateUserStart } from 'redux/session/actions';
import { Button } from 'carbon-components-react';
import Guideline from './guideline';

const FirstTimeOverlay: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector(currentUser);
  const [canShow, setCanShow] = useState(false);
  const [guidelineType, setGuidelineType] = useState('default');

  const skipOverlay = () => {
    const payload = { user_settings: { is_skip_overlay: true } };
    dispatch(updateUserStart(payload));
    setCanShow(false);
  };

  useEffect(() => {
    if (user) {
      if (user.brand_new && user.user_settings.is_skip_overlay === false) {
        setCanShow(true);
      }
      if (user.Organisation) {
        if (user.Organisation.has_create_enquiry === true) {
          setGuidelineType('canCreateNewEnquiry');
        }
      } else {
        if (user.is_as_external_user === true) {
          setGuidelineType('canCreateNewEnquiry');
        }
      }
    }
  }, [user]);
  return (
    <>
      {canShow && (
        <div className="first-time-overlay-container">
          <div className="first-time-overlay-panel">
            <div className="first-time-overlay-title">First time here?</div>
            <div className="first-time-overlay-desc">
              <Guideline type={guidelineType} />
            </div>
            <Button kind="tertiary" onClick={() => skipOverlay()}>
              OK
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(FirstTimeOverlay);
